import { render, staticRenderFns } from "./SparesReview.vue?vue&type=template&id=51a50022&scoped=true"
import script from "./SparesReview.vue?vue&type=script&lang=js"
export * from "./SparesReview.vue?vue&type=script&lang=js"
import style0 from "./SparesReview.vue?vue&type=style&index=0&id=51a50022&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a50022",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a50022')) {
      api.createRecord('51a50022', component.options)
    } else {
      api.reload('51a50022', component.options)
    }
    module.hot.accept("./SparesReview.vue?vue&type=template&id=51a50022&scoped=true", function () {
      api.rerender('51a50022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Before/ProjectInfo/SparesReview.vue"
export default component.exports